module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-Regular.b731d0b0.ttf";